import { string, object } from 'prop-types';
import * as styles from './input.module.scss';

/**
 * Omit props from an object
 * @param {object} obj - The object to omit props from
 * @param {string[]} propsToOmit - The props to omit
 * @returns {object} The object with the omitted props
 */
function omit(obj, propsToOmit) {
  const result = { ...obj };
  propsToOmit.forEach((prop) => {
    delete result[prop];
  });
  return result;
}

const Input = (props) => {
  const { id = '', type = 'text', label = '', placeholder = '', inputStatus } = props;
  const othersProps = omit(props, ['id', 'type', 'label', 'placeholder', 'inputStatus']);
  return (
    <label htmlFor={id} className={styles['formInputLabel']}>
      {label}
      <>
        <input
          {...othersProps}
          type={type}
          id={id}
          placeholder={placeholder}
          onChange={inputStatus.changeHandler}
          onBlur={inputStatus.blurHandler}
          value={inputStatus.value}
          className={`${styles['formInput']} ${inputStatus.hasError ? styles.error : ''}`}
        />
        <span
          className={`${styles['formInputSpan']} ${
            inputStatus.hasError ? styles['formInputSpanError'] : ''
          }`}
        >
          {inputStatus.hasError ? inputStatus.errorMsg : 'valid'}
        </span>
      </>
    </label>
  );
};

Input.propTypes = {
  label: string,
  id: string,
  placeholder: string,
  type: string,
  inputStatus: object,
};

export default Input;
